import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "teacher-contribute"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
var url = 'https://report.zhixuehuijiao.cn/webroot/decision/view/report?viewlet=teacher_contribution%252Fteacher_cont.cpt&ref_t=design&ref_c=915b9397-58d1-4d3a-9484-290465ccb2ee';
export default {
  __name: 'TeacherContribute',
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url
      })]);
    };
  }
};